import React from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Link,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";

const TalkToOurExpert = () => {
  return (
    <Box sx={{ maxWidth: { xs: "100%", sm: 600 }, mx: "auto", textAlign: "center", p: { xs: 2, sm: 3 }, pt: { xs: 4, sm: 6 } }}>
      <Typography variant="h6" fontWeight="bold" color="#002c77">
        Talk to our expert
      </Typography>

      <Button
        variant="contained"
        startIcon={<PhoneIcon />}
        sx={{
          backgroundImage: "linear-gradient(180deg, #2AA8E2 0%, #00337E 100%)",
          color: "#fff",
          mt: 2,
          px: { xs: 2, sm: 3 },
          fontSize: { xs: "0.8rem", sm: "1rem" },
          "&:hover": { backgroundImage: "linear-gradient(180deg, #1E7EC1 0%, #002E6B 100%)" },
        }}
      >
        Call now for free
      </Button>

      <Typography variant="body2" color="#0066cc" mt={2} fontWeight="bold">
        or
      </Typography>

      <Typography variant="h6" fontWeight="bold" color="#002c77">
        Request call back
      </Typography>

      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth size="small" label="First Name" variant="outlined" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth size="small" label="Last Name" variant="outlined" />
        </Grid>

        <Grid item xs={8}>
          <TextField fullWidth size="small" label="Mobile No." variant="outlined" />
        </Grid>
        <Grid item xs={4}>
          <Button
            variant="contained"
            fullWidth
            sx={{ backgroundColor: "#00aaff", fontSize: "0.8rem", "&:hover": { backgroundColor: "#0088cc" } }}
          >
            Send OTP
          </Button>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Stream</InputLabel>
            <Select size="small" label="Stream">
              <MenuItem value="science">Science</MenuItem>
              <MenuItem value="commerce">Commerce</MenuItem>
              <MenuItem value="arts">Arts</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Select Class</InputLabel>
            <Select size="small" label="Select Class">
              <MenuItem value="10">Class 10</MenuItem>
              <MenuItem value="11">Class 11</MenuItem>
              <MenuItem value="12">Class 12</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Center</InputLabel>
            <Select size="small" label="Center">
              <MenuItem value="delhi">Delhi</MenuItem>
              <MenuItem value="mumbai">Mumbai</MenuItem>
              <MenuItem value="bangalore">Bangalore</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField size="small" fullWidth label="Email Id" variant="outlined" />
        </Grid>
      </Grid>

      <Box mt={2} display="flex" alignItems="flex-start">
        <Checkbox size="small" />
        <Typography variant="body2">
          By submitting this form, I agree to receive all WhatsApp communication on my registered number and agreeing to Aakash's {" "}
          <Link href="#" color="primary">
            Terms Of Use
          </Link>{" "}
          and {" "}
          <Link href="#" color="primary">
            Privacy Policy
          </Link>
          .
        </Typography>
      </Box>

      <Button
        variant="contained"
        sx={{
          mt: 2,
          background: "linear-gradient(to bottom, #ffcc33, #ff9900)",
          color: "#fff",
          fontWeight: "bold",
          fontSize: { xs: "0.8rem", sm: "1rem" },
          py: 1.2,
          "&:hover": { background: "#ff8800" },
        }}
      >
        Submit Now
      </Button>
    </Box>
  );
};

export default TalkToOurExpert;